const checkServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      if (registrations.length > 0) {
        // console.log("This is a PWA context.");
        return true;
      } else {
        // console.log("This is not a PWA context.");
        return false;
      }
    });
  } else {
    // console.log("Service Worker is not supported.");
    return false;
  }
};

const checkWebAppManifest = () => {
  if (window.matchMedia("(display-mode: standalone)").matches) {
    // console.log('This is a PWA context.');
    return true;
  } else {
    // console.log('This is not a PWA context.');
    return false;
  }
};

const checkStandalone = () => {
  if (window.navigator["standalone"] === true) {
    // console.log('This is a PWA context.');
    return true;
  } else {
    // console.log('This is not a PWA context.');
    return false;
  }
};

const checkPwaFeatures = () => {
  const hasServiceWorker = "serviceWorker" in navigator;
  const hasManifest = !!document.querySelector('link[rel="manifest"]');
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;

  return hasServiceWorker && hasManifest && isStandalone;
};

const isPWA = () => {
  return (
    checkServiceWorker() ||
    checkWebAppManifest() ||
    checkStandalone() ||
    checkPwaFeatures()
  );
};

export { isPWA };
